import axios from 'axios';
import _ from 'lodash';

import { defineStore } from "pinia";
import { config } from 'vue-gtag';

window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}

export const useBuilderStore = defineStore("builder", {
  state: () => {
    return {

      quoteId: null,
      quote: {},
      quoteValidation: {},
      itemId: null,
      itemIndex: 0,
      items: [
        {
          id: null,
          quoteId: null,
          product: null,
          productId: null,
          productLayout: null,
          productLayoutId: null,
          ref: null,
          label: null,
          width: null,
          height: null,
          specs: {},
          data: {},
          valid: null,
          validStep: 1,
          adjusters: null,
        }
      ],

      mode: 'build', // default is build, possible modes are build, quote or prepare
      section: 1,
      sectionsMax: 10,
      step: 1,
      isSaved: false,
      isSubmitted: false,
      isTouched: false,
      isCp: true,
      validation: {
        step: 0,
        results: []
      },
      token: null,
      testMode: false,
      env: 'dev',
      showSummary: false,
      inputHasInitialFocus: false,

      range: {
        handle: '',
        mainTitle: 'Builder',
        itemName: 'Item'
      },
      opts: [],
      products: [],
      productLayouts: [],
      productLayoutSections: [],
      wallSpace: [],
      interior: [],
      requireDoors: [],
      panels: [],
      panel1: [],
      panel2: [],
      panel3: [],
      panel4: [],
      frames: [],
      hardware: [],
      boards: [],
      tops: [],
      depths: [],
      drawerTypes: [],
      hingedHeights: [],
      hingedDoors: [],
      corniceHeights: [],
      addRails: [],
      addShelves: [],
      delivery: {},
      benchCutouts: {},
      requireHandles: {},
      requireDesignAppointment: {},
      preferredContactMethod: {},
      requireDesignModifications: {},
      modifications: {},
      timeline: {},
      config: [],
      doorProfile: [],
      panelFinish: [],
      benchtopMaterial: [],
      handles: [],
      panelTypes: [],
      components: [],
      features: [],
      featuresFilter: [],
      featuresAvailable: {},
      featuresFilterHistory: [],
      messages: {},
      tileModType: 'benchtopMaterial',
      errors: [],

      refs: {}

    };
  },
  actions: {

    saveCurrentItem(nextStep = false, exit = false, conversion = null) {

      axios.defaults.headers.common['Authorization'] = `Bearer ${this.token}`;

      this.isTouched = true;
      this.validateCurrentItem();

      if (this.stepHasErrors) {
        this.scrollToRef('actionsGroup');
        return false;
      }

      if (!this.isSubmitted) {

        this.isSubmitted = true;
        // this.scrollToRef('builderHead');

        // set session itemId to requested edit id
        var action = '?action=my-diy-module/item/save';
        var method = 'post';

        var submitData = {
          itemId: this.itemId,
          productId: this.currentItem.productId ?? null,
          productLayoutId: this.currentItem.productLayoutId ?? null,
          label: this.currentItem.label ?? null,
          specs: this.currentItem.specs,
          firstName: this.quote.firstName,
          lastName: this.quote.lastName,
          email: this.quote.email,
          phone: this.quote.phone,
          postcode: this.quote.postcode,
          timeline: this.quote.timeline,
          testMode: this.testMode,
          featuresFilterHistory: this.featuresFilterHistory
        };
        submitData[window.csrfTokenName] = window.csrfTokenValue;

        axios({
          url: action ? action : window.location.href,
          method: method ? method : 'post',
          data: submitData,
        })
        .then((responseObject) => {
          var response = responseObject.data;

          console.log(response);

          if (response.success) {

            setTimeout(() => {
              this.isSubmitted = false;
              this.errors = [];

              this.$patch((state) => {
                state.items[state.itemIndex] = response.item;
              })

              this.$patch((state) => {
                state.quote = response.quote;
              })

              this.setCurrentItemProp('isSaved', true);

              if (exit) window.location = '/builder/save/';

              if (nextStep) this.nextScreen();

              if (this.step == 2) this.scrollToRef('builderTop');

              this.validateCurrentItem();
              this.isSaved = true;

              // clear features filter history
              this.featuresFilter = [];
              this.featuresFilterHistory = [];

              if (conversion) {

                // // kitchens conversion
                // gtag('event', 'conversion', {
                //   "send_to": conversion,
                //   "value": 1,
                //   "currency": "AUD",
                //   "transaction_id": response.quote.ref
                // });

                // pre-push the range name and handle
                window.dataLayer.push({
                  'range_name': this.quote.range.name,
                  'range_handle': this.quote.range.handle,
                });

                let pushData = {
                  'range_name': this.quote.range.name,
                  'range_handle': this.quote.range.handle,
                  'order_ref': this.quote.ref,
                  'order_price': parseFloat(this.quote.total)
                };
                console.log('trigger: mydiy_quote_saved');
                console.log(pushData);
                if (typeof dataLayer !== 'undefined') gtag('event', 'mydiy_quote_saved', pushData);

                this.quoteReceivedTrigger(true);

                // console.log('gtag fired ' + conversion + ' - ' + response.quote.ref);

              }

              return true;

            }, 500);

            // console.log('Form posted successfully');
            // console.log(response.success);
            // console.log(response);

          } else if (response.errors) {

            this.isSubmitted = false;
            this.errors = response.errors;
            // this.isSuccess = false;

            console.log('Form failed to submit');
            console.log('Field Errors', response.errors);
            console.log('Form Errors', response.formErrors);

          } else {

            this.isSubmitted = false;

          }

        })
        .catch((error) => {

          this.isSubmitted = false;

          console.error('Error!');
          console.error(error);

        });

      }

      // e.preventDefault();
      return false;

    },

    async actionPost(actionHandle, submitData, scrollToTop=true) {

      axios.defaults.headers.common['Authorization'] = `Bearer ${this.token}`;

      if (!this.isSubmitted) {

        this.isSubmitted = true;
        if (scrollToTop) this.scrollToRef('builderTop');

        var action = '?action=my-diy-module/' + actionHandle;
        var method = 'post';

        try {

          submitData[window.csrfTokenName] = window.csrfTokenValue;

          if (this.token) submitData['quoteId'] = this.quote.id;
          submitData['testMode'] = this.testMode;

          let responseObject = await axios({
            url: action ? action : window.location.href,
            method: method ? method : 'post',
            data: submitData,
          });

          this.isSubmitted = false;
          this.isSaved = true;

          let response = responseObject.data;
          if (response.success) {

            return response;

            // console.log('Form posted successfully');
            // console.log(response.success);
            // console.log(response);

          } else if (response.errors) {

            console.log('Form failed to submit');
            console.log('Field Errors', response.errors);
            console.log('Form Errors', response.formErrors);

            return false;

          } else {

            return false;

          }

        }
        catch (error) {

          this.isSubmitted = false;

          console.error('Error!');
          console.error(error);

          return false;

        }

      } else {
        return false;
      }

    },

    setCurrentItemProp(prop, val) {
      let wasEmpty = (typeof this.items[this.itemIndex][prop] !== 'undefined' && this.items[this.itemIndex][prop] !== null && this.items[this.itemIndex][prop]) ? false : true;
      this.items[this.itemIndex][prop] = val;
      this.afterCurrentItemUpdate(prop, val);
      if (this.isTouched) this.validateCurrentItem();
      if (wasEmpty) this.scrollToNext(prop);
    },

    setCurrentItemSpec(prop, val) {
      if (_.isUndefined(this.items[this.itemIndex].specs) || !_.isObject(this.items[this.itemIndex].specs)) this.items[this.itemIndex].specs = {};
      let wasEmpty = (typeof this.items[this.itemIndex].specs[prop] !== 'undefined' && this.items[this.itemIndex].specs[prop] !== null && ( this.items[this.itemIndex].specs[prop] && this.items[this.itemIndex].specs[prop] !== 117506 ) ) ? false : true;
      this.items[this.itemIndex].specs[prop] = val;
      this.afterCurrentItemUpdate(prop, val);
      if (this.isTouched) this.validateCurrentItem();
      if (wasEmpty) this.scrollToNext(prop);
    },

    setCurrentSectionSpec(prop, val) {
      if (_.isUndefined(this.items[this.itemIndex].specs.sections)) this.items[this.itemIndex].specs.sections = [];
      if (_.isUndefined(this.items[this.itemIndex].specs.sections[this.sectionIndex]) || !_.isObject(this.items[this.itemIndex].specs.sections[this.sectionIndex])) this.items[this.itemIndex].specs.sections[this.sectionIndex] = {};
      let wasEmpty = (typeof this.items[this.itemIndex].specs.sections[this.sectionIndex][prop] !== 'undefined' && this.items[this.itemIndex].specs.sections[this.sectionIndex][prop] !== null && this.items[this.itemIndex].specs.sections[this.sectionIndex][prop]) ? false : true;
      this.items[this.itemIndex].specs.sections[this.sectionIndex][prop] = val;
      this.afterCurrentItemUpdate(prop, val);
      if (this.isTouched) this.validateCurrentItem();
      if (wasEmpty && !_.isNull(val)) this.scrollToNext(prop, 'sections');
    },

    afterCurrentItemUpdate(prop, val) {

      // mirrored in ItemService php

      // update requireInternals
      if (prop == 'interiorId' || prop == 'configId') {
        if (parseFloat(val) == 2643) {
          this.items[this.itemIndex].specs.requireInternals = false;
        } else {
          this.items[this.itemIndex].specs.requireInternals = true;
        }
      }

      // update requireHandles
      if (prop == 'handlesId') {
        if (parseFloat(val) == 0) {
          this.items[this.itemIndex].specs.requireHandles = false;
        } else {
          this.items[this.itemIndex].specs.requireHandles = true;
        }
      }

      // update available width
      if (prop == 'depthId') {
        this.updateAvailableWidths();
      }

    },

    quoteReceivedTrigger(force = false) {

      if (this.mode == 'quote' && !this.quote.isReceived && this.quoteIsViewable) {

        var action = '?action=my-diy-module/quote/update';
        var method = 'post';
        try {

          let submitData = {};
          submitData[window.csrfTokenName] = window.csrfTokenValue;
          if (this.token) submitData['quoteId'] = this.quote.id;
          submitData['isReceived'] = true;

          axios({
            url: action ? action : window.location.href,
            method: method ? method : 'post',
            data: submitData,
          })
          .then((responseObject) => {
            let response = responseObject.data;
            if (response.success) {

              // pre-push the range name and handle
              window.dataLayer.push({
                'range_name': this.quote.range.name,
                'range_handle': this.quote.range.handle,
              });

              // push trigger
              let pushData = {
                'range_name': this.quote.range.name,
                'range_handle': this.quote.range.handle,
                'order_ref': this.quote.ref,
                'order_price': parseFloat(this.quote.total)
              };
              console.log('trigger: mydiy_quote_received');
              console.log(pushData);
              if (typeof dataLayer !== 'undefined') gtag('event', 'mydiy_quote_received', pushData);

              if (_.isObject(response)) {
                this.$patch((state) => {
                  state.quote = response.quote;
                })
              }
              return response;

              // console.log('Form posted successfully');
              // console.log(response.success);
              // console.log(response);

            } else if (response.errors) {

              console.log('Form failed to submit');
              console.log('Field Errors', response.errors);
              console.log('Form Errors', response.formErrors);

              return false;

            } else {

              return false;

            }

          });

        }
        catch (error) {

          console.error('Error!');
          console.error(error);

          return false;

        }

      }

    },

    featuresFilterHistoryPush() {

      if (this.featuresFilterHistory.length) {

        var action = '?action=my-diy-module/quote/push-features-filter-history';
        var method = 'post';
        try {

          let submitData = {};
          submitData[window.csrfTokenName] = window.csrfTokenValue;
          submitData['data'] = this.featuresFilterHistory;

          axios({
            url: action ? action : window.location.href,
            method: method ? method : 'post',
            data: submitData,
          })
          .then((responseObject) => {
            let response = responseObject.data;
            if (response.success) {

              this.featuresFilterHistory = [];

              // console.log('Form posted successfully');
              // console.log(response.success);
              // console.log(response);

            } else if (response.errors) {

              console.log('Form failed to submit');
              console.log('Field Errors', response.errors);
              console.log('Form Errors', response.formErrors);

              return false;

            } else {

              return false;

            }

          });

        }
        catch (error) {

          console.error('Error!');
          console.error(error);

          return false;

        }

      }

    },

    setMode(mode) {
      if (mode == 'new') document.location.href = '/builder/';
      if (mode == 'quote' && (!this.items.length || (this.items.length <= 1 && this.currentItem.validStep <= 1))) mode = 'build';
      if (['build', 'quote', 'prepare'].indexOf(mode) !== -1) {
        this.mode = mode;
        setTimeout(() => {
          this.scrollToRef('builderTop');
        }, 150);
      } else {
        this.mode = 'build';
      }
      if (!(this.isCp || this.testMode) && (this.currentItem.isCustom || this.quote.isCustom)) this.mode = 'quote';
      this.quoteReceivedTrigger();
    },

    setStep(step) {

      // automatically determine step if item exists
      if (step == 'auto') {
        if (!_.isUndefined(this.currentItem) && !_.isNull(this.currentItem.validStep)) {
          step = this.currentItem.validStep;
        } else {
          step = 1;
        }
      }

      // ensure step is a number
      step = parseFloat(step);

      // set previous step
      const prevStep = this.step;

      // ensure we don't go below 1 and above max steps
      if (step == 0) step = 1;
      else if (step > this.stepMax && this.steps.length > 1) {
        step = this.stepMax;
        this.setMode('quote')
      }

      // if no product selected then reset to step 1
      if (step > 1 && this.currentProductHandle.length <= 0) step = 1;

      // make sure it's no ahead of the valid step for the current item
      if (!_.isUndefined(this.currentItem) && !_.isNull(this.currentItem.validStep) && step > this.currentItem.validStep) step = this.currentItem.validStep;

      // console.log(this.currentItem);
      // console.log(this.currentItem.validStep);
      // console.log(this.step);

      // is touched?
      if (this.step !== step) this.isTouched = false;

      // set step
      this.step = step;

      // set section
      if (this.step == this.stepWithSections && this.step != prevStep) this.section = 1;

    },

    nextStep() {
      this.setStep(parseFloat(this.step) + 1);
    },

    setSection(section) {
      if (section == 0) section = 1;
      else if (!_.isUndefined(this.items[this.itemIndex].specs.sections) &&
        _.isArray(this.items[this.itemIndex].specs.sections) &&
        section > this.items[this.itemIndex].specs.sections.length) section = this.items[this.itemIndex].specs.sections.length;
      if (this.section !== section) this.isTouched = false;
      this.section = section;
      this.step = this.stepWithSections;
    },

    nextSection() {
      if (this.section >= this.sectionMax) {
        this.nextStep();
      } else {
        this.setSection(parseFloat(this.section) + 1);
      }
    },

    nextScreen() {
      if (!_.isUndefined(this.steps[this.step-1].hasSections) && this.steps[this.step-1].hasSections) {
        this.nextSection();
        setTimeout(() => {
          this.scrollToRef('builderTop');
        }, 150);
      } else {
        this.nextStep();
        setTimeout(() => {
          this.scrollToRef('builderTop');
        }, 150);
      }
    },

    validateCurrentItem() {

      // validation code uses json structure
      // code is reflected in ItemService php

      const item = this.currentItem;
      const section = this.currentSection;
      const structure = this.currentProductStructure;

      let validate = [
        {
          valid: true,
          errors: []
        }
      ];
      let stepWithSections = null;

      // setup validation results array
      if (this.steps.length) {
        validate = [];
        this.steps.forEach((step, index) => {
          validate.push({
            valid: true,
            errors: []
          });
          if (!_.isUndefined(step.hasSections) && step.hasSections) {
            stepWithSections = step.number;
            validate[index].sections = [];
            item.productLayoutSections.forEach((layoutSection, sectionIndex) => {
              validate[index].sections.push({
                valid: true,
                errors: []
              });
            });
          }
        });
      }

      // core specs
      const coreSpecs = ['productId', 'productLayoutId'];
      const coreSpecsNames = ['Product', 'Product Layout'];
      let isCoreValid = true;
      coreSpecs.forEach((spec, index) => {
        const rules = {
          handle: spec,
          name: coreSpecsNames[index],
          type: 'integer',
          required: true,
          step: 1
        };
        const value = item[spec] ?? null;
        if (rules) {
          const results = this.validateSpec(value, rules);
          if (!results.valid) {
            validate[results.step - 1].valid = results.valid;
            validate[results.step - 1].errors = validate[results.step - 1].errors.concat(results.errors);
            isCoreValid = false;
          }
        }
      });

      // loop through all specs and sections with validation rules
      // only if we're on a step that's past step 1
      if (structure && this.steps.length && this.step > 1) {
        for (const [handle, value] of Object.entries(item.specs)) {

          if (handle == 'sections') {

            if (!_.isUndefined(structure[handle]) && !_.isUndefined(structure[handle].sections) && _.isObject(structure[handle].sections)) {
              item.specs.sections.forEach((section, sectionIndex) => {
                for (const [sHandle, sValue] of Object.entries(section)) {
                  let getRules = structure[handle].sections[sHandle] ?? null;
                  let rules = JSON.parse(JSON.stringify(getRules));
                  const layoutSection = this.currentItem.productLayoutSections[sectionIndex];
                  if (sHandle == 'width' && layoutSection.minWidth) rules.min = layoutSection.minWidth;
                  if (rules) {
                    rules.step = structure[handle].step;
                    const results = this.validateSpec(sValue, rules);
                    if (!results.valid) {
                      if (!_.isUndefined(validate[results.step - 1].sections) && !_.isUndefined(validate[results.step - 1].sections[sectionIndex])) {
                        validate[results.step - 1].sections[sectionIndex].valid = results.valid;
                        validate[results.step - 1].sections[sectionIndex].errors = validate[results.step - 1].sections[sectionIndex].errors.concat(results.errors);

                        // add the current section errors to the step errors
                        if (this.section == (sectionIndex + 1)) {
                          validate[results.step - 1].valid = results.valid;
                          validate[results.step - 1].errors = validate[results.step - 1].errors.concat(results.errors);
                        }
                      }
                    }
                  }
                }
              });
            }


          } else {

            const rules = structure[handle] ?? null;
            if (rules) {
              const results = this.validateSpec(value, rules);
              if (!results.valid) {
                validate[results.step - 1].valid = results.valid;
                validate[results.step - 1].errors = validate[results.step - 1].errors.concat(results.errors);
              }
            }

          }

        }
      }

      let validStep = 1;
      for (let i = 0; i < this.steps.length; i ++) {
        validStep = this.steps[i].number;
        if (!validate[i].valid) {
          break;
        }
      };

      let validSection = 1;
      if (stepWithSections) {
        for (let i = 0; i < this.sectionMax; i ++) {
          validSection = i+1;
          if (_.isUndefined(validate[stepWithSections - 1].sections[i]) || !validate[stepWithSections - 1].sections[i].valid) {
            break;
          }
        }
      }

      if (isCoreValid && validStep < 2) validStep = 2;

      this.validation.step = validStep;
      this.validation.section = validSection;
      this.validation.results = validate;

      return true;

    },

    validateSpec(val, rules) {

      // validation code uses json structure
      // code is reflected in ItemService php

      // init
      const handle = rules.handle;
      const name = rules.name ?? rules.handle ?? '';
      const sections = rules.sections ?? false;
      let required = rules.required ?? false;
      const type = rules.type ?? 'string';
      const scope = rules.scope ?? 'specs';
      const step = rules.step ?? 1;
      const conditions = rules.conditions ?? false;
      const checkValue = rules.value ?? null;
      const requireEmail = rules.requireEmail ?? false;
      const msg = rules.message ?? null;
      let isValid = true;
      let errors = [];
      let keepValidating = true;

      // if scope isn't specs, get proper value
      let value = val;
      if (scope == 'quote') {
        value = this.quote[handle];
      }

      // conditions
      if (conditions) {
        let conditionsMet = 0;
        for (let i = 0; i < conditions.length; i++) {
          const conditionScope = conditions[i].scope ?? 'specs';
          const conditionHandle = conditions[i].handle;
          const conditionValue = conditions[i].value;
          const conditionOperator = conditions[i].operator ?? '=';
          if (conditionOperator == '>=') {
            if (this.currentItem[conditionScope][conditionHandle] >= conditionValue) conditionsMet ++;
          } else {
            if (this.currentItem[conditionScope][conditionHandle] == conditionValue) conditionsMet ++;
          }
        }
        if (conditionsMet == conditions.length) {
          required = true;
        } else {
          keepValidating = false;
        }
      }

      // special conditions
      if (handle == 'benchId') {
        if (!this.showBenchtopMaterialOptions) {
          required = false;
        }
      }

      // required
      if (keepValidating && required) {
        if (_.isNull(value) || value.length == 0) {
          isValid = false;
          errors.push({
            handle: handle,
            message: name + ' is required'
          });
          keepValidating = false;
        }
      }

      // value
      if (keepValidating && checkValue) {
        if (value !== checkValue) {
          isValid = false;
          errors.push({
            handle: handle,
            message: msg ?? name + ' must be equal to ' + checkValue
          });
          keepValidating = false;
        }
      }

      // integers + mods
      if (keepValidating && type == 'int') {

        // check if integer
        if (!_.isNull(value) && !_.isNumber(value)) {
          isValid = false;
          errors.push({
            handle: handle,
            message: name + ' must be an integer'
          });
          keepValidating = false;
        }

      }

      // float number
      if (keepValidating && type == 'float') {

        // check if float
        if (!_.isNull(value) && !_.isNumber(value)) {
          isValid = false;
          errors.push({
            handle: handle,
            message: name + ' must be an number'
          });
          keepValidating = false;
        }

      }

      // integers
      if (keepValidating && type == 'int' && !this.quote.isCustom) {

        const min = rules.min ?? null;
        const max = rules.max ?? null;

        // min
        if (keepValidating && min && value < min) {
          isValid = false;
          errors.push({
            handle: handle,
            message: name + ' must be greater than ' + min
          });
          keepValidating = false;
        }

        // max
        if (keepValidating && max && value > max) {
          isValid = false;
          errors.push({
            handle: handle,
            message: name + ' must be less than ' + max
          });
          keepValidating = false;
        }

      }

      // email
      if (keepValidating && type == 'email') {

        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
          isValid = false;
          errors.push({
            handle: 'email',
            message: 'Email is invalid'
          });
          keepValidating = false;
        }
      }

      // mods
      if (keepValidating && type == 'mod') {

        // we only validate mods on the server-side

      }

      // boolean
      if (keepValidating && type == 'boolean') {

        // check if true or false
        if (!_.isNull(value) && typeof value !== 'boolean') {
          isValid = false;
          errors.push({
            handle: handle,
            message: name + ' must be boolean'
          });
          keepValidating = false;
        }

      }

      return {
        step: step,
        valid: isValid,
        errors: errors
      };

    },

    scrollToNext(prop, scope = 'specs') {

        // builder.config.fieldName + 'SubGroup'
      setTimeout(() => {

        const structure = this.currentProductStructure;

        if (structure) {

          const lastSpec = structure[Object.keys(structure)[Object.keys(structure).length - 1]];
          let spec = structure[prop];
          if (scope == 'sections') spec = structure.sections.sections[prop];

          if (!_.isUndefined(spec) && (spec.type !== 'int' || spec.handle == 'addRails' || spec.handle == 'addShelves') && prop !== 'boardId') {

            let refHandle = 'actionsGroup';
            let elExists = false;
            if (!_.isUndefined(spec.nextHandle)) {
              refHandle = spec.nextHandle;

              try {
                this.refs[refHandle].getBoundingClientRect().top;
                elExists = true;
              }
              catch(e){
                elExists = false;
              }
              if (!elExists) {
                try {
                  this.refs[refHandle][0].getBoundingClientRect().top;
                  elExists = true;
                }
                catch(e){
                  elExists = false;
                }
              }

            } else {
              let keys = Object.keys(structure);
              let i = 0;
              do {

                i++;

                let nextIndex = keys.indexOf(prop) + i;
                let nextItem = keys[nextIndex];
                let nextSpec = structure[nextItem];

                if (nextSpec && spec.step == nextSpec.step) {
                  refHandle = nextSpec.handle + 'Group';
                }

                try {
                  this.refs[refHandle].getBoundingClientRect().top;
                  elExists = true;
                }
                catch(e){
                  elExists = false;
                }
                if (!elExists) {
                  try {
                    this.refs[refHandle][0].getBoundingClientRect().top;
                    elExists = true;
                  }
                  catch(e){
                    elExists = false;
                  }
                }

                if (!elExists && nextSpec == lastSpec) {
                  refHandle = 'actionsGroup';
                  elExists = true;
                }

              }
              while (!_.isUndefined(keys[keys.indexOf(prop) + i]) && ( _.isUndefined(this.refs[refHandle]) || _.isNull(this.refs[refHandle] || !_.isElement(this.refs[refHandle])) || !elExists ) )
            }

            // if (refHandle == 'actionsGroup') {window.scroll(0, newScrollY);

            //   return;
            // }

            if (!_.isUndefined(this.refs[refHandle]) && !_.isNull(this.refs[refHandle]) && elExists) this.scrollToRef(refHandle);
            return;

          }

        }

        if (prop == 'configGroupId') {
          if (this.configOptionsForConfigGroup.length) {
            this.scrollToRef(this.config.fieldName + 'SubGroup');
            return;
          }
        }

        if ((prop == 'productId' || prop == 'productLayoutId') && !_.isNull(this.currentItem[prop])) {
          if (prop == 'productId' && !_.isUndefined(this.refs['productLayoutIdGroup']) && this.range.handle !== 'kitchens') {
            this.scrollToRef('productLayoutIdGroup');
          } else if (prop !== 'productId') {
            this.scrollToRef('actionsGroup');
          }
          return;

        }

      }, 150);

    },

    scrollToRef(ref) {

      // get ref element
      let refEl = this.refs[ref];
      if (_.isArray(refEl)) refEl = refEl[0];
      if (_.isUndefined(refEl)) return false;
      if (_.isNull(refEl)) return false;

      // get offset height
      let offsetHeight = 128;
      if (window.innerWidth <= 1200) offsetHeight = 80;
      // if (document.querySelector('.site-header')) offsetHeight += document.querySelector('.site-header').offsetHeight;
      if (document.querySelector('.site-banner')) offsetHeight += document.querySelector('.site-banner').offsetHeight;

      let newScrollY = null;
      if (ref == 'actionsGroup') {
        newScrollY = window.scrollY + this.refs['builderFrame'].getBoundingClientRect().top + this.refs['builderFrame'].offsetHeight - window.innerHeight + offsetHeight - 40;
      } else {
        newScrollY = window.scrollY + refEl.getBoundingClientRect().top - offsetHeight - 20;
      }

      if (window.innerWidth <= 768) {
        newScrollY += 40;
        if (document.querySelector('.site-banner')) newScrollY -= 40;
      }

      if (newScrollY == 0) newScrollY = 1;

      if (newScrollY) {
        window.scroll(0, newScrollY);
        refEl.focus();
      }
    },

    setItemId(itemId) {
      this.itemId = itemId;
      this.itemIndex = this.items.map(e => e.id).indexOf(this.itemId);
    },

    setItemIndexFromItemId() {
      this.itemIndex = this.items.map(e => e.id).indexOf(this.itemId);
    },

    updateUrl() {

      // update url
      const sep = '/';
      let pageUrl = '/builder/';

      // set group handle

      // set mode and step
      if (this.mode == 'build') {
        if (!_.isUndefined(this.step) && this.step > 1) pageUrl += this.step + sep;
      } else if (!_.isUndefined(this.mode) && this.mode.length) {
        pageUrl += this.mode + sep;
      }

      // add search params on
      pageUrl += window.location.search;

      // // push it
      // let pageTitle = 'Builder'; //todo
      // history.pushState({
      //   id: 'builder',
      //   mode: this.mode,
      //   step: this.step
      // }, pageTitle, pageUrl);

    },

    displayPriceIncludeGst(value) {
      let price = value * 1.1;
      let priceToFormat = price;
      let prepend = '';
      if (price < 0) {
        priceToFormat = (price * -1);
        prepend = '- ';
      }
      return prepend + priceToFormat.toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2
      });
    },

    filterSubConfigs(allOpts, configGroup) {

      let filteredOpts = [];

      if (!_.isUndefined(allOpts) && !_.isUndefined(this.currentItem.productLayoutSections) && !_.isNull(this.currentItem.productLayoutSections)) {

        for (let i = 0; i < allOpts.length; i++) {

          let isValid = false;

          if (configGroup && configGroup['configIds'] && configGroup['configIds'].indexOf(allOpts[i]['id']) !== -1) {
            isValid = true;
          }

          // sub config
          if (allOpts[i]['type'] !== 'sub') isValid = false;

          // min width
          if (isValid) {
            let minWidth = (parseFloat(allOpts[i]['minWidth']) > 0) ? parseFloat(allOpts[i]['minWidth']) : 0;
            if (this.currentSectionAvailableWidth < minWidth) isValid = false;
          }

          // max width
          if (isValid) {
            let maxWidth = (parseFloat(allOpts[i]['maxWidth']) > 0) ? parseFloat(allOpts[i]['maxWidth']) : 9999999999999;
            if (this.currentSectionAvailableWidth > maxWidth) isValid = false;
          }

          if (isValid) {
            filteredOpts.push(allOpts[i]);
          }

        }

      }

      if (filteredOpts.length == 1) {
        var index = this.config.options.map(function(e) { return e.id; }).indexOf(filteredOpts[0].configParentId);
        this.config.options[index].overrideTitle = filteredOpts[0].title;
        this.config.options[index].overrideImage = filteredOpts[0].image;
        this.config.options[index].overrideGallery = filteredOpts[0].gallery;
      } else if (filteredOpts.length > 1) {
        var index = this.config.options.map(function(e) { return e.id; }).indexOf(filteredOpts[0].configParentId);
        this.config.options[index].overrideTitle = null;
        this.config.options[index].overrideImage = null;
        this.config.options[index].overrideGallery = null;
      }

      return filteredOpts;

    },

    updateAvailableWidths() {
      if (!_.isUndefined(this.currentItem.specs.sections) && _.isArray(this.currentItem.specs.sections) && this.currentItem.specs.sections.length) {
        this.currentItem.specs.sections.forEach((section, index) => {
          this.setCurrentSectionSpec('designWidth', this.getAvailableWidth(section, index, this.currentItem));
        });
      }
    },

    getAvailableWidth(section, sectionIndex, item) {

      const userWidth = section.width ?? item.specs.width;

      if (
        !_.isUndefined(userWidth) &&
        !_.isUndefined(item.productLayoutSections) &&
        _.isArray(item.productLayoutSections) &&
        item.productLayoutSections.length &&
        !_.isUndefined(item.data.wallSpace)
        ) {
          console.log(item.productLayoutSections)
        const layoutSection = item.productLayoutSections[sectionIndex];
        const wallSpaceSlug = item.data.wallSpace.slug;
        let wallSpaceWidth = 0;

        // kitchens / laundries
        if (item.productId == 3 || item.productId == 4) {
          if (layoutSection.lhsType == 'end') {
            if (wallSpaceSlug.search('infill-lhs') !== -1) {
              wallSpaceWidth += 30;
            } else {
              wallSpaceWidth += 16;
            }
          }
          if (layoutSection.rhsType == 'end') {
            if (wallSpaceSlug.search('infill-rhs') !== -1) {
              wallSpaceWidth += 30;
            } else {
              wallSpaceWidth += 16;
            }
          }

        // hinged wardrobes
        } else if (item.productId == 8) {

          if (wallSpaceSlug.search('infill-lhs') !== -1) {
            wallSpaceWidth += 40;
          } else {
            wallSpaceWidth += 16;
          }

          if (wallSpaceSlug.search('infill-rhs') !== -1) {
            wallSpaceWidth += 40;
          } else {
            wallSpaceWidth += 16;
          }

        // walk in wardrobes
        } else if (item.productId == 2) {
          const depthValue = item.data.depth.value ?? 587;
          if (layoutSection.lhsType == 'join') {
            wallSpaceWidth += depthValue;
          }
          if (layoutSection.rhsType == 'join') {
            wallSpaceWidth += depthValue;
          }
        }

        const availableWidth = userWidth - wallSpaceWidth;
        return availableWidth;
      } else if (!_.isUndefined(item.specs.width)) {
        return item.specs.width;
      }

      return 0;

    }

  },
  getters: {

    currentItem: (state) => {
      return state.items[state.itemIndex];
    },

    currentSection: (state) => {
      if (state.items[state.itemIndex].specs && state.items[state.itemIndex].specs.sections && _.isNumber(state.sectionIndex)) {
        return state.items[state.itemIndex].specs.sections[state.sectionIndex];
      }
      return {};
    },

    currentSectionHasCorner: (state) => {
      if (
        !_.isUndefined(state.currentItem.productLayoutSections) &&
        _.isArray(state.currentItem.productLayoutSections) &&
        state.currentItem.productLayoutSections.length) {
        const layoutSection = state.currentItem.productLayoutSections[state.sectionIndex]
        if (layoutSection.lhsType == 'corner' || layoutSection.rhsType == 'corner') {
          return true;
        }
      }
      return false;
    },

    currentSectionAvailableWidth: (state) => {

      const availableWidth = state.getAvailableWidth(state.currentSection, state.sectionIndex, state.currentItem);
      state.currentSection.designWidth = availableWidth;
      return availableWidth;

    },

    currentSectionType: (state) => {
      const layoutSection = state.currentItem.productLayoutSections[state.sectionIndex];
      if (layoutSection && layoutSection.title.includes('Island')) return 'island';
      return 'wall';
    },

    currentSectionConfigGroup: (state) => {
      if (state.currentSection.configGroupId) {
        const isConfigValid = state.configOptionsForSection.find(obj => {
          return obj.id === state.currentSection.configGroupId
        })
        const config = state.configOptions.find(obj => {
          return obj.id === state.currentSection.configGroupId
        })
        if (!_.isUndefined(config) && isConfigValid) {
          return config;
        }
      }
      return null;
    },

    currentSectionConfig: (state) => {
      if (state.currentSection.configId) {
        let isConfigValid = state.configOptionsForSection.find(obj => {
          return obj.id === state.currentSection.configId
        })
        if (!isConfigValid && state.currentSectionConfigGroup && state.currentSectionConfigGroup.configIds.length) {
          isConfigValid = state.currentSectionConfigGroup.configIds.indexOf(state.currentSection.configId) !== -1;
        }
        const config = state.configOptions.find(obj => {
          return obj.id === state.currentSection.configId
        })
        if (!_.isUndefined(config) && isConfigValid) {
          return config;
        }
      } else if (state.currentItem.specs.configId) {
        const config = state.configOptions.find(obj => {
          return obj.id === state.currentItem.specs.configId
        })
        if (!_.isUndefined(config)) {
          return config;
        }
      }
      return null;
    },

    currentSectionConfigDescription: (state) => {
      if (state.currentSection.configId) {
        const config = state.currentSectionConfig;
        const wallSpace = state.wallSpaceOptions.find(obj => {
          return obj.id === state.currentItem.specs.wallSpaceId
        })
        if (!_.isUndefined(config)) {

          // code is reflected in ItemService php

          let title = config.title;
          if (!_.isNull(config.displayTitle) && config.displayTitle.length) title = config.displayTitle;
          let str = '';

          // title
          str += '<h5>' + title + '</h5>';
          let hasDescription = false;
          if (!_.isNull(config.description) && config.description.length) hasDescription = true;
          if (hasDescription) str += config.description.trim();
          let wrapInParagraph = false;
          let preTitleString = '<br><br>';
          let postContentString = '';
          let lastTag = str.substring(str.length - 4);
          if (lastTag == '</p>') wrapInParagraph = true;
          if (wrapInParagraph) preTitleString = '<p>';
          if (wrapInParagraph) postContentString = '</p>';
          let regex = '/(<p([^>]+)>|</p>)/ig';
          str = str.replace(regex, '');

          // components & materials (wardrobes)
          if ([2, 7, 8].indexOf(state.currentItem.productId) !== -1) {
            const componentsObject = JSON.parse(config.components);

            // corner component check
            let cornerComponentStr = '';
            const layoutSection = state.currentItem.productLayoutSections[state.sectionIndex]
            const cornerComponent = state.components.find(obj => {
              return obj.slug === 'walkin-corner-component'
            });
            if (layoutSection.lhsType == 'corner' || layoutSection.rhsType == 'corner') {
              cornerComponentStr = '1 x ' + (cornerComponent.displayTitle ?? cornerComponent.title);
            }

            // components
            if (!_.isNull(componentsObject) && _.isObject(componentsObject)) {
              if (preTitleString == '<br><br>' && hasDescription) str += preTitleString;
              let sep = '';
              for (const [id, qty] of Object.entries(componentsObject)) {
                if (parseFloat(qty) > 0) {
                  const component = state.components.find(obj => {
                    return obj.id === parseFloat(id)
                  })
                  if (!_.isUndefined(component)) {
                    str += sep + qty + ' x ' + (component.displayTitle ?? component.title);
                    sep = '<br>';
                  }
                }
              }
              if (cornerComponentStr.length) {
                str += sep + cornerComponentStr;
              }
              str += postContentString;
            }

            // materials
            if (!_.isNull(config.materials) && config.materials.length) {
              str += preTitleString;
              str += config.materials;
              str += postContentString;
            }

          }

          // init widths
          const widthDifference = config.maxWidth - state.currentSectionAvailableWidth;

          // variable cabinets
          const variableLowerWidth = (parseFloat(config.variableCabinetMaxWidth) - widthDifference);
          const variableUpperWidth = variableLowerWidth;
          str = str.replaceAll(/{variableLowerWidth}/g, variableLowerWidth);
          str = str.replaceAll(/{variableUpperWidth}/g, variableUpperWidth);

          // fridge
          let fridgeSectionWidth = 900;
          // if fridge is against a wall, subtract 30mm
          const lhsPanel = config.lhsEndPanelType ?? null;
          const rhsPanel = config.rhsEndPanelType ?? null;
          if (
              ( lhsPanel == 'fridge' && wallSpace.slug.search('infill-lhs') !== -1 ) ||
              ( rhsPanel == 'fridge' && wallSpace.slug.search('infill-rhs') !== -1 )
          ) {
              fridgeSectionWidth -= 30;
          }
          fridgeSectionWidth = fridgeSectionWidth;
          str = str.replaceAll(/{fridgeSectionWidth}/g, fridgeSectionWidth);

          // wallspace components
          const layoutSection = state.currentItem.productLayoutSections[state.sectionIndex]
          const wallSpaceSlug = state.currentItem.data.wallSpace.slug;
          const titleString = '<strong>Wall Space Components</strong>';
          let hasTitle = false;

          if (layoutSection.lhsType == 'end' || layoutSection.lhsType == 'endIsland') {
            const lhsPanelType = config.lhsEndPanelType;
            state.panelTypes.forEach(panelType => {
              if (panelType.slug == lhsPanelType) {
                panelType.combos.forEach(combo => {
                  if (wallSpaceSlug.search(combo.wallSpace + '-lhs') !== -1) {
                    if (!_.isNull(combo.components) && _.isObject(combo.components)) {
                      if (!hasTitle) {
                        str += preTitleString;
                        str += titleString;
                        hasTitle = true;
                      }
                      for (const id in combo.components) {
                        const qty = parseFloat(combo.components[id]);
                        const component = state.components.find(obj => {
                          return obj.id === parseFloat(id)
                        })
                        for (let i = 1; i <= qty; i ++) {
                          if (!_.isUndefined(component)) {
                            str += '<br>' + (component.displayTitle ?? component.title);
                          }
                        }
                      }
                    }
                  }
                });
              }
            });
          }

          if (layoutSection.rhsType == 'end' || layoutSection.rhsType == 'endIsland') {
            const rhsPanelType = config.rhsEndPanelType;
            state.panelTypes.forEach(panelType => {
              if (panelType.slug == rhsPanelType) {
                panelType.combos.forEach(combo => {
                  if (wallSpaceSlug.search(combo.wallSpace + '-rhs') !== -1) {
                    if (!_.isNull(combo.components) && _.isObject(combo.components)) {
                      if (!hasTitle) {
                        str += preTitleString;
                        str += titleString;
                        hasTitle = true;
                      }
                      for (const id in combo.components) {
                        const qty = parseFloat(combo.components[id]);
                        const component = state.components.find(obj => {
                          return obj.id === parseFloat(id)
                        })
                        for (let i = 1; i <= qty; i ++) {
                          if (!_.isUndefined(component)) {
                            str += '<br>' + (component.displayTitle ?? component.title);
                          }
                        }
                      }
                    }
                  }
                });
              }
            });
          }

          if (wrapInParagraph && hasTitle) str += '</p>';

          return str;
        }
      }
      return '';
    },

    selectedSections: (state) => {
      let allOpts = state.config.options;
      let filteredOpts = [];
      let sectionConfigIds = [];

      if (!_.isUndefined(allOpts) && !_.isUndefined(state.currentItem.specs.sections)) {
        state.currentItem.specs.sections.forEach(section => {
          filteredOpts.push(allOpts.find(({ id }) => id === section.configId));
        });
      }

      // return allOpts.find(({ id }) => id === section.configId);
      // ((el) => {
      //   return sectionConfigIds.indexOf(el.configId) !== -1;
      // });


      return filteredOpts;
    },

    currentItemBenchWidth: (state) => {

      let benchWidth = 0;
      if (!_.isUndefined(state.currentItem.specs.sections) && _.isArray(state.currentItem.specs.sections)) {
        state.currentItem.specs.sections.forEach(section => {
          if (section.configId) {
            const config = state.configOptions.find(obj => {
              return obj.id === section.configId
            })
            if (config) {
              benchWidth += config.benchtopWidth;
            }
          }
        });
      }
      return benchWidth;

    },

    currentItemDoorCount: (state) => {

      let doorCount = 0;
      if (!_.isUndefined(state.currentItem.productLayoutId) && !_.isNull(state.currentItem.productLayoutId)) {
        var productLayout = null;
        if (!_.isUndefined(state.productLayouts.options)) {
          productLayout = state.productLayouts.options.find(obj => {
            return obj.id === state.currentItem.productLayoutId
          });
        }
        if (productLayout) doorCount = parseFloat(productLayout.slug.split('-')[1]);
      }

      if (!doorCount) {
        if (!_.isUndefined(state.productLayouts.options)) {
          let doorCounts = [];
          state.hingedWardrobeLayoutOptions.forEach(section => {
            // doorCount = parseFloat(section.slug.split('-')[1]);
            doorCounts.push(parseFloat(section.slug.split('-')[1]));
          });
          doorCounts = [...new Set(doorCounts)];
          if (doorCounts.length == 1) doorCount = doorCounts[0];
        }
      }
      return doorCount;

    },

    currentItemDoorWidth: (state) => {

      let doorWidth = Math.round(state.currentSectionAvailableWidth / state.currentItemDoorCount);
      return doorWidth;

    },

    currentProductHandle: (state) => {
      const productId = state.items[state.itemIndex].productId;
      let productHandle = '';
      if (!_.isNull(state.items[state.itemIndex].product) && !_.isUndefined(state.items[state.itemIndex].product.handle)) {
        productHandle = state.items[state.itemIndex].product.handle
        if (productHandle.length) return productHandle.charAt(0).toUpperCase() + productHandle.slice(1);
      }
      return '';
    },

    currentProductTitle: (state) => {
      const productId = state.items[state.itemIndex].productId;
      if (!_.isUndefined(state.products.options)) {
        var product = state.products.options.find(obj => {
          return obj.id === productId
        });
        if (product) return product.title;
      }
      return '';
    },

    currentProductStructure: (state) => {
      if (!_.isNull(state.items[state.itemIndex].product) && !_.isUndefined(state.items[state.itemIndex].product.structure)) {
        return JSON.parse(state.items[state.itemIndex].product.structure);
      }
      return null;
    },

    currentSelectedFeatures: (state) => {
      const item = state.items[state.itemIndex];
      let features = {};
      state.features.forEach(feature => {
        // features[feature.title] = 0;
        features[feature.id] = {
          id: feature.id,
          title: feature.title,
          qty: 0
        };
      })

      if (state.currentItem.productId == 3 || state.currentItem.productId == 5) {
        item.specs.sections.forEach(section => {
          const config = state.configOptions.find(obj => {
            return obj.id === section.configId
          })
          if (config) {
            const components = JSON.parse(config.components);
            if (!_.isNull(components)) {
              for (const [compId, compQty] of Object.entries(components)) {
                const qty = parseFloat(compQty);
                if (qty) {
                  const component = state.components.find(obj => {
                    return obj.id === parseFloat(compId)
                  });
                  component.features.forEach(feature => {
                    features[feature.id].qty += qty;
                  })
                }
              }
            }
          }
        });
      }

      return features;
    },

    isWardrobeBuilder: (state) => {
      if (['wardrobes'].includes(state.range.handle)) {
        return true;
      }
      return false;
    },

    isKlBuilder: (state) => {
      if (['kitchens', 'laundries'].includes(state.range.handle)) {
        return true;
      }
      return false;
    },

    hasPrepareStep: (state) => {
      // remove kitchens and laundries prepare step 3/2/2025
      // if (state.currentItem.productId == 3 || state.currentItem.productId == 5) {
      //   return true;
      // }
      return false;
    },

    productOptions: (state) => {
      return state.products.options;
    },

    productLayoutOptions: (state) => {
      if (!_.isEmpty(state.productLayouts)) {
        return state.productLayouts.options.filter((el) => {
          return el.productId == state.currentItem.productId
        });
      }
      return [];
    },

    kitchenLayoutOptions: (state) => {
      return state.productLayoutOptions;
    },

    laundryLayoutOptions: (state) => {
      return state.productLayoutOptions;
    },

    walkInWardrobeLayoutOptions: (state) => {
      let allOpts = state.productLayoutOptions;
      var filteredOpts = [];

      if (!_.isUndefined(allOpts)) {
        for (var i = 0; i < allOpts.length; i++) {
          if (allOpts[i].productId !== 8) {
            filteredOpts.push(allOpts[i]);
          }
        }
      }

      return filteredOpts;
    },

    hingedWardrobeLayoutOptions: (state) => {
      let allOpts = state.productLayoutOptions;
      var filteredOpts = [];

      if (!_.isUndefined(allOpts)) {
        for (var i = 0; i < allOpts.length; i++) {
          let doors = parseFloat(allOpts[i].slug.split('-')[1]);
          if (doors >= parseFloat(state.currentItem.specs.doorsMin) && doors <= parseFloat(state.currentItem.specs.doorsMax)) {
            filteredOpts.push(allOpts[i]);
          }
        }
      }

      return filteredOpts;
    },

    wallSpaceOptions: (state) => {
      if (!_.isUndefined(state.wallSpace.options)) return state.wallSpace.options;
      return [];
    },

    interiorOptions: (state) => {
      var allOpts = state.interior.options;
      var filteredOpts = [];

      if (!_.isUndefined(allOpts)) {
        for (var i = 0; i < allOpts.length; i++) {
          if (allOpts[i]['requiredId'].indexOf(String(state.currentItem.specs.doorsId)) !== -1 || allOpts[i]['requiredId'].indexOf(state.currentItem.specs.doorsId) !== -1) {
            var minWidth = (parseFloat(allOpts[i]['minWidth']) > 0) ? parseFloat(allOpts[i]['minWidth']) : 0;
            var maxWidth = (parseFloat(allOpts[i]['maxWidth']) > 0) ? parseFloat(allOpts[i]['maxWidth']) : 9999999999999;
            if (parseFloat(state.currentItem.specs.width) >= minWidth && parseFloat(state.currentItem.specs.width) <= maxWidth) {
              filteredOpts.push(allOpts[i]);
            }
          }
        }
      }

      return filteredOpts;
    },

    interiorOptionsForSection: (state) => {
      let allOpts = state.interior.options;
      let filteredOpts = [];

      // hinged wardrobes
      let isHinged = false;
      if (!_.isUndefined(state.config.options) && (state.currentItem.productId == 8)) {
        isHinged = true;
      }

      if (!_.isUndefined(allOpts) && !_.isUndefined(state.currentItem.productLayoutSections) && !_.isNull(state.currentItem.productLayoutSections) && _.isArray(state.currentItem.productLayoutSections)) {

        let doorsId = state.currentItem.productLayoutSections[state.sectionIndex].doorsId ?? null;

        for (let i = 0; i < allOpts.length; i++) {
          // if (allOpts[i]['requiredId'].indexOf(String(state.currentSection.doorsId)) !== -1 || allOpts[i]['requiredId'].indexOf(state.currentSection.doorsId) !== -1) {

            let isValid = true;

            if (!isHinged) {

              // product layout sections
              let productLayoutSectionIds = allOpts[i]['productLayoutSectionIds'];
              let currentSectionId = state.currentItem.productLayoutSections[state.sectionIndex].id;
              if (productLayoutSectionIds) {
                if (productLayoutSectionIds.search('all') == -1) {
                  let sectionIds = JSON.parse(productLayoutSectionIds.replaceAll('"', ''));
                  if (sectionIds.indexOf(currentSectionId) == -1) {
                    isValid = false;
                  }
                }
              } else {
                isValid = false;
              }

              // min width
              let minWidth = (parseFloat(allOpts[i]['minWidth']) > 0) ? parseFloat(allOpts[i]['minWidth']) : 0;
              if (parseFloat(state.currentSection.width) < minWidth) isValid = false;

              // max width
              let maxWidth = (parseFloat(allOpts[i]['maxWidth']) > 0) ? parseFloat(allOpts[i]['maxWidth']) : 9999999999999;
              if (parseFloat(state.currentSection.width) > maxWidth) isValid = false;

            }

            if (isHinged) {

              // product layout sections
              let productLayoutSectionIds = allOpts[i]['productLayoutSectionIds'];
              let currentSectionId = doorsId;
              if (productLayoutSectionIds) {
                if (productLayoutSectionIds.search('all') == -1) {
                  let sectionIds = JSON.parse(productLayoutSectionIds.replaceAll('"', ''));
                  if (sectionIds.indexOf(currentSectionId) == -1) {
                    isValid = false;
                  }
                }
              } else {
                isValid = false;
              }

              // hinged door config
              // if (allOpts[i]['requiredId'].indexOf(doorsId) == -1) isValid = false;

            }

            if (isValid) filteredOpts.push(allOpts[i]);

            if (!isValid && state.currentSection.interiorId == allOpts[i].id) {
              state.currentSection.interiorId = null;
            }

          // }
        }

      }

      return filteredOpts;
    },

    requireDoorsOptions: (state) => {
      if (!_.isUndefined(state.requireDoors.options)) return state.requireDoors.options;
      return [];
    },

    panelsOptions: (state) => {
      var allOpts = state.panels.options;
      var filteredOpts = [];

      if (!_.isUndefined(allOpts)) {
        for (var i = 0; i < allOpts.length; i++) {
          var minWidth = (parseFloat(allOpts[i]['minWidth']) > 0) ? parseFloat(allOpts[i]['minWidth']) : 0;
          var maxWidth = (parseFloat(allOpts[i]['maxWidth']) > 0) ? parseFloat(allOpts[i]['maxWidth']) : 9999999999999;
          if (parseFloat(state.currentItem.specs.width) >= minWidth && parseFloat(state.currentItem.specs.width) <= maxWidth) {
            filteredOpts.push(allOpts[i]);
          }
        }
      }

      return filteredOpts;
    },

    framesOptions: (state) => {
      if (!_.isUndefined(state.frames.options)) return state.frames.options;
      return [];
    },

    hardwareOptions: (state) => {
      if (!_.isUndefined(state.hardware.options)) return state.hardware.options;
      return [];
    },

    boardsOptions: (state) => {
      if (!_.isUndefined(state.boards.options)) return state.boards.options;
      return [];
    },

    showTopFillMessage: (state) => {
      if (state.currentItem.specs.height > 2750 && state.currentItem.specs.height <= 2850) return true;
      return false;
    },

    showTopsOptions: (state) => {
      if (state.topsOptions.length > 1) return true;
      return false;
    },

    topsOptions: (state) => {
      // if (!_.isUndefined(state.tops.options)) return state.tops.options;
      // return [];
      var allOpts = state.tops.options;
      var filteredOpts = [];

      if (!_.isUndefined(allOpts)) {
        for (var i = 0; i < allOpts.length; i++) {
          var minHeight = (parseFloat(allOpts[i]['minHeight']) > 0) ? parseFloat(allOpts[i]['minHeight']) : 0;
          var maxHeight = (parseFloat(allOpts[i]['maxHeight']) > 0) ? parseFloat(allOpts[i]['maxHeight']) : 9999999999999;
          var compareHeight = parseFloat(state.currentItem.specs.height);
          if (compareHeight > minHeight && compareHeight <= maxHeight) {
            filteredOpts.push(allOpts[i]);
          }
        }
      }

      return filteredOpts;
    },

    hingedTopsOptions: (state) => {
      if (!_.isUndefined(state.tops.options)) return state.tops.options;
      return [];
    },

    depthsOptions: (state) => {
      if (!_.isUndefined(state.depths.options)) return state.depths.options;
      return [];
    },

    showDrawerTypesOptions: (state) => {
      if (state.currentSectionConfig && state.currentSectionConfig.hasDrawers) return true;
      return false;
    },

    drawerTypesOptions: (state) => {
      if (!_.isUndefined(state.drawerTypes.options)) return state.drawerTypes.options;
      return [];
    },

    hingedHeightsOptions: (state) => {
      if (!_.isUndefined(state.hingedHeights.options)) return state.hingedHeights.options;
      return [];
    },

    showHingedHeight: (state) => {
      if (state.currentItem && state.currentItem.specs.heightId == 127150) return true;
      return false;
    },

    // hingedDoorsOptions: (state) => {
    //   if (!_.isUndefined(state.hingedDoors.options)) return state.hingedDoors.options;
    //   return [];
    // },

    hingedDoorsOptions: (state) => {
      if (_.isUndefined(state.hingedDoors.options)) return [];
      var allOpts = state.hingedDoors.options;
      var filteredOpts = [];

      if (!_.isUndefined(allOpts)) {
        for (var i = 0; i < allOpts.length; i++) {
          var doors = parseFloat(allOpts[i]['doors']);
          if (doors >= parseFloat(state.currentItem.specs.doorsMin) && doors <= parseFloat(state.currentItem.specs.doorsMax)) {
            filteredOpts.push(allOpts[i]);
          }
        }
      }

      return filteredOpts;
    },

    corniceHeightsOptions: (state) => {
      if (!_.isUndefined(state.corniceHeights.options)) return state.corniceHeights.options;
      return [];
    },

    addRailsOptions: (state) => {
      if (!_.isUndefined(state.addRails.options)) return state.addRails.options;
      return [];
    },

    addShelvesOptions: (state) => {
      if (!_.isUndefined(state.addShelves.options)) return state.addShelves.options;
      return [];
    },

    deliveryOptions: (state) => {
      if (!_.isUndefined(state.delivery.options)) return state.delivery.options;
      return [];
    },

    doorProfileOptions: (state) => {
      let newOpts = _.orderBy(state.doorProfile.options, ['subGroupSeq'], ['asc']);
      let subGroups = [];
      newOpts.forEach(item => {
        let displaySubGroupTitle = false;
        if (!subGroups.includes(item.subGroup)) {
          subGroups.push(item.subGroup);
          displaySubGroupTitle = true;
        }
        item.displaySubGroupTitle = displaySubGroupTitle;
      });
      return newOpts;
    },

    panelFinishOptions: (state) => {
      let newOpts = _.orderBy(state.panelFinish.options, ['subGroupSeq'], ['asc']);
      let subGroups = [];
      newOpts.forEach(item => {
        let displaySubGroupTitle = false;
        if (!subGroups.includes(item.subGroup)) {
          subGroups.push(item.subGroup);
          displaySubGroupTitle = true;
        }
        item.displaySubGroupTitle = displaySubGroupTitle;
      });
      let showOpts = [];
      newOpts.forEach(item => {
        let show = false;
        if (_.isEmpty(item.requiredModIds) || item.requiredModIds.includes(state.currentItem.specs.doorProfileId)) {
          show = true;
        }
        if (show) {
          showOpts.push(item);
        }
      });

      return showOpts;
    },

    showBenchtopMaterialOptions: (state) => {
      if (state.currentItemBenchWidth > 0) return true;
      return false;
    },

    benchtopMaterialOptions: (state) => {
      let newOpts = _.orderBy(state.benchtopMaterial.options, ['subGroupSeq'], ['asc']);
      let subGroups = [];
      newOpts.forEach(item => {
        let displaySubGroupTitle = false;
        if (!subGroups.includes(item.subGroup)) {
          subGroups.push(item.subGroup);
          displaySubGroupTitle = true;
        }
        item.displaySubGroupTitle = displaySubGroupTitle;
      });
      return newOpts;
    },

    showBenchCutoutsOption: (state) => {
      if (!_.isUndefined(state.benchtopMaterial.options) && !_.isUndefined(state.items[state.itemIndex].specs.benchId) && !_.isNull(state.items[state.itemIndex].specs.benchId)) {
        const benchMaterialOption = state.benchtopMaterial.options.filter((el) => {
          return el.id == state.items[state.itemIndex].specs.benchId
        });
        if (benchMaterialOption[0].subGroup == 'Metro Caesarstone Benchtop Range - 20mm') {
          return true;
        }
      }
      return false;
    },

    benchCutoutsOptions: (state) => {
      if (!_.isUndefined(state.benchCutouts.options)) return state.benchCutouts.options;
      return [];
    },

    requireHandlesOptions: (state) => {
      if (!_.isUndefined(state.requireHandles.options)) return state.requireHandles.options;
      return [];
    },

    showHandlesOptions: (state) => {
      if (!_.isUndefined(state.items[state.itemIndex].specs.requireHandles) && !_.isNull(state.items[state.itemIndex].specs.requireHandles)) {
        if (state.items[state.itemIndex].specs.requireHandles === true) {
          return true;
        }
      }
      return false;
    },

    handlesOptions: (state) => {
      if (!_.isUndefined(state.handles.options)) {
        var opts = state.handles.options;
        opts.push({
          id: 0,
          title: 'No Handles required, I’ll source my own',
          description: null,
          image: null,
          gallery: null,
          subGroup: '',
          subGroupSeq: 0
        });
        return opts;
      }
      return [];
    },

    allModOptions: (state) => {
      if (_.isUndefined(state[state.tileModType]) || _.isUndefined(state[state.tileModType].options)) return [];
      let newOpts = state[state.tileModType].options;
      return newOpts;
    },

    requireDesignAppointmentOptions: (state) => {
      if (!_.isUndefined(state.requireDesignAppointment.options)) return state.requireDesignAppointment.options;
      return [];
    },

    preferredContactMethodOptions: (state) => {
      if (!_.isUndefined(state.preferredContactMethod.options)) return state.preferredContactMethod.options;
      return [];
    },

    requireDesignModificationsOptions: (state) => {
      if (!_.isUndefined(state.requireDesignModifications.options)) return state.requireDesignModifications.options;
      return [];
    },

    timelineOptions: (state) => {
      if (!_.isUndefined(state.timeline.options)) return state.timeline.options;
      return [];
    },

    tileTypeOptions: (state) => {
      return [
        {
          id: 'image',
          title: 'Image',
        },
        {
          id: 'mod',
          title: 'Mod',
        },
      ];
    },

    configOptions: (state) => {
      if (!_.isUndefined(state.config.options)) return state.config.options;
      return [];
    },

    configOptionsForSection: (state) => {
      let allOpts = state.config.options;
      let validOpts = [];
      let filteredOpts = [];

      if (state.currentItem.productId == 2 || state.currentItem.productId == 3 || state.currentItem.productId == 5 || state.currentItem.productId == 7) {

        if (!_.isUndefined(state.config.options) && !_.isUndefined(state.currentItem.productLayoutSections) && !_.isNull(state.currentItem.productLayoutSections)) {

          // reset available features
          state.featuresAvailable = {};
          for (let j = 0; j < state.features.length; j++) {
            const featureId = state.features[j].id;
            state.featuresAvailable[featureId] = 0;
          }

          // only loop through if we have a valid width for the section
          let sectionWidth = null;
          if (!_.isNil(state.currentSection.width)) sectionWidth = state.currentSection.width;
          else if (!_.isNil(state.currentItem.specs.width)) sectionWidth = state.currentItem.specs.width;

          let minWidth = 0;
          if (!_.isUndefined(state.currentProductStructure.sections)) minWidth = state.currentProductStructure.sections.sections.width.min;
          if (!_.isNull(state.configOptionsMinWidth)) minWidth = state.configOptionsMinWidth;
          if (sectionWidth && sectionWidth >= minWidth) {
          // if (!_.isNull(state.currentSection.width)) {

            for (let i = 0; i < allOpts.length; i++) {
              // if (allOpts[i]['requiredId'].indexOf(String(state.currentSection.doorsId)) !== -1 || allOpts[i]['requiredId'].indexOf(state.currentSection.doorsId) !== -1) {

                let isValid = true;
                let isFiltered = true;

                // product layout sections
                if (isValid) {
                  let productLayoutSectionIds = allOpts[i]['productLayoutSectionIds'];
                  let currentSectionId = state.currentItem.productLayoutSections[state.sectionIndex].id;
                  if (productLayoutSectionIds) {
                    if (productLayoutSectionIds.search('all') == -1) {
                      let sectionIds = JSON.parse(productLayoutSectionIds.replaceAll('"', ''));
                      if (sectionIds.indexOf(currentSectionId) == -1) {
                        isValid = false;
                      }
                    }
                  } else {
                    isValid = false;
                  }
                }

                // standard config
                if (allOpts[i]['type'] !== 'standard') isValid = false;

                // min width
                if (isValid) {
                  let minWidth = (parseFloat(allOpts[i]['minWidth']) > 0) ? parseFloat(allOpts[i]['minWidth']) : 0;
                  if (state.currentSectionAvailableWidth < minWidth) isValid = false;
                }

                // max width
                if (isValid) {
                  let maxWidth = (parseFloat(allOpts[i]['maxWidth']) > 0) ? parseFloat(allOpts[i]['maxWidth']) : 9999999999999;
                  if (state.currentSectionAvailableWidth > maxWidth) isValid = false;
                }

                // required mod id
                if (isValid) {
                  let requiredModId = parseFloat(allOpts[i]['requiredId']);
                  if (requiredModId && requiredModId !== state.currentItem.specs.doorsId) isValid = false;
                }

                // filtered features
                if (isValid) {
                  // if (state.featuresFilter.length) {
                    let featuresRequired = state.featuresFilter.length;
                    let featuresCount = 0;
                    let featuresMatched = [];
                    for (let j = 0; j < allOpts[i].features.length; j++) {
                      const featureId = allOpts[i].features[j];
                      if (state.featuresFilter.indexOf(featureId) !== -1 && featuresMatched.indexOf(featureId) == -1) {
                        featuresMatched.push(featureId);
                        featuresCount ++;
                      }
                      if (!state.featuresFilter.length) {
                        state.featuresAvailable[featureId]++;
                      }
                    }
                    if (state.featuresFilter.length && featuresCount >= featuresRequired) {
                      for (let j = 0; j < allOpts[i].features.length; j++) {
                        const featureId = allOpts[i].features[j];
                        state.featuresAvailable[featureId]++;
                      }
                    }
                    if (state.featuresFilter.length && featuresCount < featuresRequired) isFiltered = false;
                  // }
                }

                // config group
                let subConfigs = allOpts.filter(obj => {
                  return obj.configParentId === allOpts[i].id;
                });
                let filteredSubConfigs = state.filterSubConfigs(subConfigs, allOpts[i]);

                if (isValid) validOpts.push(allOpts[i]);
                if (isValid && isFiltered) filteredOpts.push(allOpts[i]);


              // }
            }

          }

        }

        const isConfigValid = validOpts.find(obj => {
          return obj.id === state.currentSection.configId
        })

        const isConfigGroupValid = validOpts.find(obj => {
          return obj.id === state.currentSection.configGroupId
        })

        if (state.stepWithSections && !_.isUndefined(state.currentSection.configGroupId) && !_.isNull(state.currentSection.configGroupId)) {
          if (!isConfigGroupValid) {
            state.setCurrentSectionSpec('configGroupId', null);
            state.setCurrentSectionSpec('configId', null);
          }
        } else {
          if (!isConfigValid && state.stepWithSections) state.setCurrentSectionSpec('configId', null);
        }

      }

      return filteredOpts;
    },

    configOptionsForConfigGroup: (state) => {

      let filteredOpts = [];

      if (!_.isNil(state.currentSectionConfigGroup)) {
        let subConfigs = state.config.options.filter(obj => {
          return obj.configParentId === state.currentSectionConfigGroup.id;
        });
        filteredOpts = state.filterSubConfigs(subConfigs, state.currentSectionConfigGroup);
      }

      return filteredOpts;

    },

    showConfigVariations: (state) => {
      if (state.configOptionsForConfigGroup.length > 1) return true;
      return false;
    },

    configVariationTerm: (state) => {
      let hasDrawers = false;
      state.configOptionsForConfigGroup.forEach(config => {
        if (config.hasDrawers) hasDrawers = true;
      });
      if (hasDrawers) return 'drawer';
      return 'shelf';
    },

    allConfigOptionsForSection: (state) => {

      let allOpts = state.config.options;
      let filteredOpts = [];

      // walk-in wardrobes, kitchens and laundries
      if (!_.isUndefined(state.config.options) && (state.currentItem.productId == 2 || state.currentItem.productId == 3 || state.currentItem.productId == 5) && _.isArray(state.currentItem.productLayoutSections) && !_.isUndefined(state.currentItem.productLayoutSections[state.sectionIndex])) {
        for (let i = 0; i < allOpts.length; i++) {

          let isValid = true;

          // product layout sections
          let productLayoutSectionIds = allOpts[i]['productLayoutSectionIds'];
          let currentSectionId = state.currentItem.productLayoutSections[state.sectionIndex].id;
          if (productLayoutSectionIds) {
            if (productLayoutSectionIds.search('all') == -1) {
              let sectionIds = JSON.parse(productLayoutSectionIds.replaceAll('"', ''));
              if (sectionIds.indexOf(currentSectionId) == -1) {
                isValid = false;
              }
            }
          } else {
            isValid = false;
          }

          if (isValid) filteredOpts.push(allOpts[i]);

        }
      }

      return filteredOpts;

    },

    configOptionsMinWidth: (state) => {

      let allOpts = state.allConfigOptionsForSection;
      let minWidth = null;

      if (state.currentItem.productId == 3 || state.currentItem.productId == 5) {
        for (let i = 0; i < allOpts.length; i++) {
          if (allOpts[i]) {
            if ( _.isNull(minWidth) || ( allOpts[i].minWidth > 0 && allOpts[i].minWidth < minWidth ) ) {
              minWidth = allOpts[i].minWidth;
            }
          }
        }
      }

      return minWidth;

    },

    configOptionsMaxWidth: (state) => {

      let allOpts = state.allConfigOptionsForSection;
      let maxWidth = null;

      if (state.currentItem.productId == 2 || state.currentItem.productId == 3 || state.currentItem.productId == 5) {
        for (let i = 0; i < allOpts.length; i++) {
          if (allOpts[i]) {
            if ( _.isNull(maxWidth) || ( allOpts[i].maxWidth > maxWidth ) ) {
              maxWidth = allOpts[i].maxWidth;
            }
          }
        }
      }

      return maxWidth;

    },

    stepComponentName: (state) => {
      return 'Step' + state.step;
    },

    pageTitle: (state) => {
      let string = '';
      if (state.currentItem.product) {
        string = '<strong>' + state.currentItem.product.title;
        if (state.subTitle) {
          string += ':';
        }
        string += '</strong>';
        if (state.subTitle) {
          string += ' ' + state.subTitle;
        }
      }
      return string;
    },

    subTitle: (state) => {
      if (state.currentItem.productId == 1) {
        if (state.currentItem.data.wallSpace) {
          return state.currentItem.data.wallSpace.title;
        } else {
          return '';
        }
      }
      if (!_.isNull(state.currentItem.productLayout)) {
        return state.currentItem.productLayout.title;
      }
      return '';
    },

    steps: (state) => {
      if (state.currentItem.product) {
        return JSON.parse(state.currentItem.product.stepsStructure);
      }
      return [
        {
          number: 1,
          title: 'Type and Layout',
          nextText: 'Start Building',
          saveText: 'Save and exit'
        }
      ];
    },

    stepMax: (state) => {
      return state.steps.length;
    },

    stepWithSections: (state) => {
      for (let i = 0; i < state.steps.length; i++) {
        if (!_.isUndefined(state.steps[i].hasSections) && state.steps[i].hasSections) {
          return i+1;
        }
      }
      return null;
    },

    sectionIndex: (state) => {
      if (state.section) {
        return state.section - 1;
      }
      return 0;
    },

    sectionMax: (state) => {
      if (!_.isUndefined(state.currentItem)) {

        // // hinged
        // if (state.currentItem.productId == 8) {
        //   if (!_.isUndefined(state.currentItem.data.doorConfig.slug)) {
        //     let sections = state.currentItem.data.doorConfig.slug.split('-').length - 1;
        //     return sections;
        //     // return state.currentItem.productLayout.sectionsCount;
        //   }
        // }

        // // everything else
        // else {
          if (!_.isUndefined(state.currentItem) && state.currentItem.productLayout) {
            return state.currentItem.productLayout.sectionsCount;
          }
        // }

      }
      return 1;
    },

    sectionTitle: (state) => {
      if (!_.isUndefined(state.currentItem) && state.currentItem.productLayout && !_.isEmpty(state.productLayouts.options)) {
        const currentProductLayoutId = state.currentItem.productLayout.id;
        const currentLayout = state.productLayouts.options.find(obj => {
          return obj.id === currentProductLayoutId
        })
        if (currentLayout.sections[state.sectionIndex]) return currentLayout.sections[state.sectionIndex].title;
      }
      return '';
    },

    sectionTitles: (state) => {
      if (!_.isUndefined(state.currentItem) && state.currentItem.productLayout && !_.isEmpty(state.productLayouts.options)) {
        const currentProductLayoutId = state.currentItem.productLayout.id;
        const currentLayout = state.productLayouts.options.find(obj => {
          return obj.id === currentProductLayoutId
        })
        let titles = [];
        currentLayout.sections.forEach(section => {
          titles.push(section.title);
        });
        return titles;
      }
      return [];
    },

    allValidationErrors: (state) => {
      let allErrors = [];
      for (let i = 1; i <= state.stepMax; i++) {
        if (!_.isUndefined(state.errors) && !_.isUndefined(state.errors[i])) allErrors.concat(state.errors[i]);
      }
      return allErrors;
    },

    stepHasErrors: (state) => {
      if (
        !_.isUndefined(state.validation.results) &&
        !_.isUndefined(state.validation.results[state.step - 1]) &&
        !_.isUndefined(state.validation.results[state.step - 1].errors) &&
        state.validation.results[state.step - 1].errors.length) {
        return true;
      }
      return false;
    },

    stepErrors: (state) => {
      if (state.stepHasErrors) return state.validation.results[state.step - 1].errors;
      else return [];
    },

    // isCp: (state) => {
    //   if (!_.isNull(state.token) && state.token.length) {
    //     return true;
    //   }
    //   return false;
    // },

    itemsMax: (state) => {
      if (state.range.handle == 'wardrobes') {
        return 10;
      } else {
        return 10;
      }
    },

    canAddMoreItems: (state) => {
      const itemsTotal = state.items.length;
      let sectionsTotal = 0;
      state.items.forEach(item => {
        if (!_.isUndefined(item.specs.sections) && _.isArray(item.specs.sections)) {
          item.specs.sections.forEach(section => {
            sectionsTotal ++;
          });
        }
      })
      if (itemsTotal >= state.itemsMax || sectionsTotal >= state.sectionsMax - 3) {
        return false;
      }
      if (state.range.handle !== 'wardrobes') return false;
      return true;
    },

    isLegacyQuote: (state) => {
      let isLegacyQuote = false;
      if (!_.isUndefined(state.quote) && state.quote.builderVersion < 2) {
        isLegacyQuote = true;
      }
      if (!_.isUndefined(state.quote) && !state.quote.ordered) {
        state.items.forEach(item => {
          if (!_.isUndefined(item.productId) && item.productId == 1) {
            isLegacyQuote = true;
          }
        })
      }
      return isLegacyQuote;
    },

    requiresRecalculation: (state) => {
      let requiresRecalculation = false;
      if (!_.isUndefined(state.quote) && state.quote.requiresRecalculation) {
        requiresRecalculation = true;
      }
      return requiresRecalculation;
    },

    quoteIsViewable: (state) => {
      if (!state.quote.viewable && !state.isCp) return false;
      return true;
    },

    quoteNeedsSubtotal: (state) => {
      if (!_.isUndefined(state.quote)) {
        if ((state.quote.totalItems * 1.1).toFixed(2) == state.quote.total) {
          return false;
        }
      }
      return true;
    },

    quoteHasMultipleItems: (state) => {
      if (!_.isUndefined(state.quote)) {
        if (state.items.length > 1) {
          return true;
        }
      }
      return false;
    },

    quoteAlert: (state) => {

      let hasAlert = false;
      let alertText = '';

      state.items.forEach(item => {
        if (item.productId == 3) {
          if (item.specs.requireDesignAppointment) {
            hasAlert = true;
            alertText = '<strong>You\'ve requested a design appointment to help finalise your quote.</strong> <br />We\'ll be in touch via email to schedule an appointment shortly.';
          }
          if (item.specs.requireDesignModifications) {
            hasAlert = true;
            alertText = '<strong>You\'ve requested some design modifications to your kitchen.</strong> <br />We\'ll be in touch via email to confirm your quote shortly.';
          }
          if (item.specs.requireDesignAppointment && item.specs.requireDesignModifications) {
            hasAlert = true;
            alertText = '<strong>You\'ve requested some design modifications and a design appointment to finalise your quote.</strong> <br />We\'ll be in touch via email to schedule an appointment shortly.';
          }
        } else if (item.productId == 3) {
          if (item.specs.requireDesignAppointment) {
            hasAlert = true;
            alertText = '<strong>You\'ve requested a design appointment to help finalise your quote.</strong> <br />We\'ll be in touch via email to schedule an appointment shortly.';
          }
          if (item.specs.requireDesignModifications) {
            hasAlert = true;
            alertText = '<strong>You\'ve requested some design modifications to your laundry.</strong> <br />We\'ll be in touch via email to confirm your quote shortly.';
          }
          if (item.specs.requireDesignAppointment && item.specs.requireDesignModifications) {
            hasAlert = true;
            alertText = '<strong>You\'ve requested some design modifications and a design appointment to finalise your quote.</strong> <br />We\'ll be in touch via email to schedule an appointment shortly.';
          }
        }
      });

      if (hasAlert) alertText += ' <br />Alternatively, <a href="https://calendly.com/diykitchens" target="_blank">schedule your appointment now</a>.'

      if (!hasAlert) alertText = '';

      return alertText;

    },

    firstNamePossesive: (state) => {
      if (!_.isNull(state.quote.firstName) && state.quote.firstName.length) {
        return state.quote.firstName + "'s";
      }
      return 'My';
    },

    refShort: (state) => {
      if (!_.isNull(state.quote.ref) && state.quote.ref.length) {
        let ref = state.quote.ref;
        ref = ref.split('-');
        ref.splice(1, 1);
        return ref.join('-');
      }
      return '';
    }

  }
});
